import { ChangeDetectionStrategy, Component, ElementRef, inject, signal, viewChild } from '@angular/core';
import { email, form, FormField, required } from '@angular/forms/signals';
import { MatMiniFabButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-newsletter-block',
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatMiniFabButton,
    MatIcon,
    FormField,
    RouterLink,
    TranslocoDirective,
  ],
  templateUrl: './newsletter-block.component.html',
  styleUrl: './newsletter-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterBlockComponent {
  private thisElement = inject(ElementRef<HTMLElement>);
  newsletterEmailForm = form(signal(''), (p) => {
    email(p);
    required(p);
  });
  emailInput = viewChild<ElementRef<HTMLInputElement>>('emailInput');

  focusInputField() {
    this.thisElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.emailInput()?.nativeElement?.focus({ preventScroll: true });
  }
}
